import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

/**
 * Marks a URL as safe to load in a resource context (e.g. <iframe src>). Angular
 * blocks dynamic resource URLs by default as an XSS guard, so binding a value that
 * came from an API response directly to [src] on an iframe needs this. Only use
 * this on URLs your own code has fully constructed/validated — never on a raw,
 * unvalidated string from an external source.
 */
@Pipe({
  name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string | undefined | null): SafeResourceUrl | undefined {
    return url ? this.sanitizer.bypassSecurityTrustResourceUrl(url) : undefined;
  }
}
